import { useEffect } from "react";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import type { DataAwareResponse } from "@/types/types";
import errorNotifications from "@/helper/helper";
import { toast } from "react-toastify";
import { AxiosError } from "axios";

type Props<T> = UseQueryOptions<DataAwareResponse<T>, Error, DataAwareResponse<T>, string[]>;

export function useQueryWithValidation<TData>({ ...restOptions }: Props<TData>) {
  const query = useQuery({
    ...restOptions,
  });

  const validationItems = query?.data?.validation?.items;

  useEffect(() => {
    if (validationItems?.length) {
      errorNotifications(validationItems);
    }
  }, [validationItems?.length]);

  useEffect(() => {
    if (query.isError) {
      if (query.error instanceof AxiosError) {
        const axiosError = query.error as AxiosError;
        const status = axiosError.response?.status;

        if (status === 400) {
          toast.error("Bad Request - Please check your input.");
        } else if (status === 401) {
          toast.error("Unauthorized ");
        } else if (status === 403) {
          toast.error("Forbidden - You do not have permission.");
        } else if (status === 404) {
          toast.error("Resource not found.");
        } else if (status === 500) {
          toast.error("Server error - Please try again later.");
        } else {
          toast.error("An error occurred during the request");
        }
      } else if (query.error instanceof Error) {
        toast.error(query.error.message);
      } else {
        toast.error("Critical error - please contact support");
      }
    }
  }, [query.error, query.isError]);

  return query;
}
